import { createAction } from '@reduxjs/toolkit';
import { IOrder } from '../../../../dto';
import { ACT_SET, MN_ORDERS, TYPE_ELEMENT } from '../../../../common';

export const setOrder = createAction<IOrder>(
  `${MN_ORDERS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
